<!-- src/views/FirstView.vue -->
<template>
  <div class="customer-count-container">
    <div class="welcome-section">
      <div class="logo">
        <el-icon :size="60" color="#ff6b6b">
          <Food />
        </el-icon>
      </div>
      <h1>{{ tableStore.tenantName }}</h1>
      <p class="table-no">桌号：<span style="color:red;">{{ tableStore.tableNo }}</span></p>
      <p class="subtitle">请选择用餐人数，我们将为您推荐合适的菜品</p>
    </div>
    
    <div class="count-selection">
      <div class="count-title">
        <h2>用餐人数</h2>
        <p>请选择本次用餐的人数</p>
      </div>
      
      <div class="count-options">
        <div 
          v-for="count in 12" 
          :key="count"
          class="count-option"
          :class="{ 'selected': customerCnt === count }"
          @click="selectCount(count)"
        >
          <div class="count-label">{{ count + '人' + (count == 12 ? '+' : '') }}</div>
        </div>
      </div>
      
      <div class="custom-count" v-if="customerCnt >= 12">
        <div class="custom-title">自定义人数</div>
        <div class="custom-controls">
          <el-button 
            :icon="Minus" 
            circle 
            @clicek="decCustomer"
            :disabled="customerCnt <= 12"
          />
          <div class="custom-display">
            <span class="custom-number">{{ customerCnt }}</span>
            <span class="custom-unit">人</span>
          </div>
          <el-button 
            :icon="Plus" 
            circle 
            @click="incCustomer"
            :disabled="customerCnt >= 20"
          />
        </div>
      </div>
    </div>
    
    <div class="action-section">
      <el-button 
        type="primary" 
        size="large" 
        @click="startOrdering"
        :disabled="customerCnt == 0"
        class="start-btn"
      >
        开始点餐
        <el-icon class="ml-2">
          <Right />
        </el-icon>
      </el-button>
    </div>
  </div>
</template>

<script setup>
import { onBeforeMount, ref } from 'vue'
import { useRouter, useRoute} from 'vue-router'
import { Food, Minus, Plus, Right } from '@element-plus/icons-vue'
import { useTableStore } from '@/stores/common/tableStore'
import { ElMessage } from 'element-plus'
import socketService from '@/utils/socketService'

const router = useRouter()
const route = useRoute()

const tableStore = useTableStore();

// 人数
const customerCnt = ref(0)

// 选择人数
const selectCount = (count) => {
  customerCnt.value = count
  tableStore.setCustomerCnt(count)
}

// 自定义人数操作
const incCustomer = () => {
  if (customerCnt.value < 20) {
    customerCnt.value++
  }
}

const decCustomer = () => {
  if (customerCnt.value > 1) {
    customerCnt.value--
  }
}

// 开始点餐
const startOrdering = () => {
  if (customerCnt.value > 0) {
    tableStore.setStartTime()
    router.push('/orderMenu')
  }
}

onBeforeMount( async () => {
  const queryTableNo = route.query.tableNo
  if(!queryTableNo){
    router.push('/forbidden')
    ElMessage.error('请重新扫码')
    return
  }

  // 创建websocket连接
  socketService.connect(queryTableNo)

  // 当前
  tableStore.setTableNo(queryTableNo)
  
  // 当前tableSessionId取得
  await tableStore.getTableDetailByTableNo()
  
  // 进餐中的情况下，直接跳转到点单画面
  if( tableStore.tableSessionId ){
    router.push('/orderComfirm')
  }
})
</script>

<style scoped>
.customer-count-container {
  padding: 24px 16px;
  min-height: 100vh;
  background: linear-gradient(180deg, #fff8f8 0%, #ffffff 100%);
}

.welcome-section {
  text-align: center;
  margin-bottom: 20px;
}

.logo {
  margin-bottom: 10px;
}

.welcome-section h1 {
  color: #333;
  font-size: 24px;
  font-weight: 600;
  margin-bottom: 8px;
}

.subtitle {
  color: #666;
  font-size: 14px;
}

.table-no {
  color: #666;
  font-size: 18px;
}

.count-selection {
  background: white;
  border-radius: 16px;
  padding: 24px;
  margin-bottom: 24px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
}

.count-title {
  margin-bottom: 24px;
}

.count-title h2 {
  color: #333;
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 4px;
}

.count-title p {
  color: #888;
  font-size: 14px;
}

.count-options {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
  margin-bottom: 32px;
}

.count-option {
  background: #f8f9fa;
  border-radius: 12px;
  padding: 20px 12px;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s ease;
  border: 2px solid transparent;
}

.count-option:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.08);
}

.count-option.selected {
  border-color: #ff6b6b;
  background: linear-gradient(135deg, #fff5f5 0%, #ffeaea 100%);
}

.count-option.selected .el-icon {
  color: #ff6b6b;
}

.count-number {
  position: absolute;
  font-size: 14px;
  font-weight: bold;
  color: white;
}

.count-label {
  color: #666;
  font-size: 13px;
  font-weight: 500;
}

.custom-count {
  background: #f8f9fa;
  border-radius: 12px;
  padding: 20px;
}

.custom-title {
  color: #333;
  font-weight: 600;
  margin-bottom: 16px;
  text-align: center;
}

.custom-controls {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 24px;
  margin-bottom: 16px;
}

.custom-display {
  background: white;
  border-radius: 8px;
  padding: 8px 24px;
  min-width: 100px;
  text-align: center;
}

.custom-number {
  font-size: 28px;
  font-weight: bold;
  color: #ff6b6b;
  margin-right: 4px;
}

.custom-unit {
  color: #666;
  font-size: 14px;
}

.action-section {
  text-align: center;
  margin: 40px 0;
}

.start-btn {
  padding: 16px 48px;
  font-size: 16px;
  font-weight: 600;
  border-radius: 25px;
  background: linear-gradient(135deg, #ff6b6b 0%, #ff8e53 100%);
  border: none;
  box-shadow: 0 4px 15px rgba(255, 107, 107, 0.3);
  transition: all 0.3s ease;
}

.start-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(255, 107, 107, 0.4);
}

.start-btn:disabled {
  background: #ccc;
  transform: none;
  box-shadow: none;
}

.bottom-tips {
  text-align: center;
  margin-top: 40px;
  padding: 16px;
  background: #f8f9fa;
  border-radius: 12px;
  color: #666;
  font-size: 13px;
}

.bottom-tips .el-icon {
  color: #ff8e53;
  margin-right: 8px;
  vertical-align: middle;
}
</style>